
<template>
  <v-app id="onHanr">
    <v-main>
    <v-container fluid>  
    <v-card>
      
      Nr: {{hanr.hanr_nr}} &nbsp; - &nbsp;  {{hanr.hanr_oms}}

      <span v-for="(hanrtaalRecord,i) in hanr.hanrtaal" :key="i">
       <br>
       {{hanrtaalRecord.taal_code}}  <v-btn class="primary ma-2" small @click="saveHanrtaal(hanrtaalRecord)">Save</v-btn><br>
       <v-textarea v-model="hanrtaalRecord.hanrtaal_oms_klnt" :value=hanrtaalRecord.hanrtaal_oms_klnt rows="4" label="Guest Translation" spellcheck="false"></v-textarea>
       <v-textarea v-model="hanrtaalRecord.hanrtaal_oms_klnt_pay_not_vfy" :value=hanrtaalRecord.hanrtaal_oms_klnt_pay_not_vfy rows="4" label="Guest Translation Payment not to VFY" spellcheck="false"></v-textarea>
       <v-textarea v-model="hanrtaalRecord.hanrtaal_oms_eign" :value=hanrtaalRecord.hanrtaal_oms_eign rows="4" label="Host Translation" spellcheck="false"></v-textarea>
       <br>
      </span>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/> 
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['hanr_encrid'],
  data() {
    return {
      hanr: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/hanr/getHanr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHanr"
          },
          getHanr: {
             hanr_encrid: this.hanr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hanr = res.data.getHanr;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    saveHanrtaal(hanrtaal) { 
      this.$axios
        .post("ares/json/ares/syst/ref/hanr/saveHanrtaal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveHanrtaal"
          },
          saveHanrtaal: {
            hanrtaal: hanrtaal
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveHanrtaal.text,
              color: res.data.saveHanrtaal.color
            });
          }
        })
    }
  }  

};

</script> 
